import React from "react";
import { connect } from "react-redux";
import { Paper, Typography, Grid, Button, Box } from "@mui/material";
import endpoint from "../../../config/endpoints";
import { apiGet } from "../../../utils/api_service";
import { withRouter } from "../../../components/withRouter";
import { noInternetMsg } from "../../../config/messageconstant";
import { showLoador, showNotification } from "../../Landing/Landing.slice";
import LandingScreenHeader from "../../../components/Comman/LandingScreenHeader";

const LabelWithShowMore = ({ label, value }) => {
  const [showAll, setShowAll] = React.useState(false);
  const valuesArray = typeof value === "string" ? value.split(",") : [];
  const displayedValues = showAll ? valuesArray : valuesArray.slice(0, 7);
  const shouldShowMore = valuesArray.length > 7;

  return (
    <Grid
      item
      xs={12}
      sm={valuesArray?.length > 7 ? 12 : 6}
      md={valuesArray?.length > 7 ? 12 : 6}
      lg={valuesArray?.length > 7 ? 12 : 6}
    >
      <Box display="flex" alignItems="flex-start">
        <Typography
          variant="body1"
          component="span"
          sx={{
            color: "#39c1d4",
            fontWeight: 500,
            minWidth: "298px",
            flexShrink: 0,
          }}
        >
          {label} :
        </Typography>

        <Box
          sx={{
            display: "inline",
            flex: 1,
            wordBreak: "break-word",
            whiteSpace: "normal",
          }}
        >
          <Typography
            variant="body1"
            component="span"
            sx={{
              wordBreak: "break-word",
              whiteSpace: "normal",
            }}
          >
            {displayedValues.join(", ")}{" "}
          </Typography>

          {shouldShowMore && (
            <Button
              onClick={() => setShowAll(!showAll)}
              size="small"
              sx={{
                textTransform: "none",
                padding: "0px 4px",
                minWidth: "auto",
                fontSize: "12px",
                color: "#39c1d4",
              }}
            >
              {showAll ? "Show Less" : "Show More"}
            </Button>
          )}
        </Box>
      </Box>
    </Grid>
  );
};

class ManagerView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      headerData: {},
    };
  }

  async componentDidMount() {
    const { showLoador, showNotification, params } = this.props;
    if (navigator.onLine) {
      if (params.id) {
        showLoador({ loador: true });
        await apiGet({
          url: endpoint.salesExecutive + "/by-id?id=" + this.props.params.id,
        }).then(({ data, success }) => {
          showLoador({ loador: false });
          if (success) {
            this.setState({ headerData: data.data });
          }
        });
      }
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  }

  onCancel = () => {
    this.props.navigate(-1);
  };

  render() {
    const { headerData } = this.state;

    let isShowSalesTeamHomeAddress =
      localStorage.getItem("isShowSalesTeamHomeAddress") == 1;

    return (
      <Paper sx={{ p: 2, borderRadius: 0 }} elevation={0}>
        <LandingScreenHeader
          screenTitle={"Sales Manager View"}
          showTable={false}
          showBackButton={true}
          showAddButton={false}
          onCancel={this.onCancel}
        />

        <br></br>

        <Grid container spacing={2}>

          {isShowSalesTeamHomeAddress && (
            <>
              <LabelWithShowMore label="Latitude" value={headerData?.latitude || "-"} />

              <LabelWithShowMore label="Longitude" value={headerData?.longitude || "-"} />

              <LabelWithShowMore
                label="Home Address"
                value={headerData?.homeAddress || "-"}
              />
            </>
          )}


          <LabelWithShowMore
            label="Type"
            value={headerData?.stockStakeHolderType?.name}
          />

          <LabelWithShowMore label=" User Name" value={headerData?.userName} />

          <LabelWithShowMore label="Name" value={headerData?.name} />

          <LabelWithShowMore
            label="Employee Code"
            value={headerData?.employeeCode}
          />

          <LabelWithShowMore
            label="Reporting Manager Type"
            value={headerData?.reportingManagerTypeName}
          />

          <LabelWithShowMore
            label="Reporting Manager"
            value={headerData?.reportingManagerName}
          />

          {localStorage.getItem("isShowLeaveAndClaimAuthorityType") == 1 && (
            <>
              <LabelWithShowMore
                label="Leave Reporting Manager Type"
                value={headerData?.leaveAuthorityTypeName}
              />

              <LabelWithShowMore
                label="Leave Reporting Manager"
                value={headerData?.leaveAuthorityName}
              />

              <LabelWithShowMore
                label="Balance Leave"
                value={String(headerData?.carryForwardLeave)}
              />

              <LabelWithShowMore
                label="Claim Reporting Manager Type"
                value={headerData?.claimAuthorityTypeName}
              />

              <LabelWithShowMore
                label="Claim Reporting Manager"
                value={headerData?.claimAuthorityName}
              />
            </>
          )}


          {localStorage.getItem("isShowDojAtSalesTeam") === "1" && (
            <>
              <LabelWithShowMore
                label="Date Of Joining"
                value={headerData.dateOfJoining !== null ? headerData.dateOfJoining : "-"}
              />

              <LabelWithShowMore
                label="Date Of Leaving"
                value={headerData.dateOfLeaving !== null ? headerData.dateOfLeaving : "-"}
              />
            </>
          )}

          {localStorage.getItem("showTargetTypeRadioGroup") === "1" && (
            <LabelWithShowMore
              label="Target Type"
              value={
                headerData.type === 0
                  ? "Value Wise target"
                  : headerData.type === 1
                    ? "Beat wise target"
                    : headerData.type === 2
                      ? "RU wise target"
                      : "-"
              }
            />
          )}

          <LabelWithShowMore label="Contact No" value={headerData?.contactNo} />

          <LabelWithShowMore
            label="WhatsApp No"
            value={headerData?.whatsAppNo}
          />

          <LabelWithShowMore label="Email Id" value={headerData?.emailId} />

          <LabelWithShowMore
            label="Region"
            value={headerData.regionNames || "-"}
          />
          <LabelWithShowMore
            label="State"
            value={headerData.stateNames || "-"}
          />
          <LabelWithShowMore label="Zone" value={headerData.zoneNames || "-"} />
          <LabelWithShowMore
            label="District"
            value={headerData.districtNames || "-"}
          />
          <LabelWithShowMore
            label="Taluka"
            value={headerData.talukaNames || "-"}
          />
          <LabelWithShowMore label="Area" value={headerData.areaNames || "-"} />
        </Grid>
      </Paper>
    );
  }
}

const mapStateToProps = (state) => ({});
const mapDispatchToProps = {
  showNotification,
  showLoador,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ManagerView));
